export const translations = {
  sr: {
    // Navigation
    home: 'Početna',
    services: 'Usluge',
    pricing: 'Cenovnik',
    about: 'O nama',
    gallery: 'Galerija',
    contact: 'Kontakt',
    booking: 'Zakazivanje',
    
    // Hero
    heroTitle: 'Omiljeno mesto vašeg psa',
    heroSubtitle: 'Uživanje u grooming tretmanu, od njuške do repa',
    viewServices: 'Pogledaj usluge',
    contactUs: 'Kontaktiraj nas',
    
    // Services
    servicesTitle: 'Naše usluge',
    servicesSubtitle: 'Profesionalna nega prilagođena potrebama vašeg ljubimca',
    learnMore: 'Saznaj više',
    close: 'Zatvori',
    
    // Service names
    grooming: 'Šišanje',
    bathing: 'Kupanje',
    maintenance: 'Održavanje',
    furminating: 'Furminiranje',
    trimming: 'Trimovanje',
    
    // Service descriptions
    groomingDesc: 'Profesionalno šišanje prilagođeno tipu dlake i želji vlasnika.',
    bathingDesc: 'Tretman osvežavanja sa balzamom, šamponima po tipu kože.',
    maintenanceDesc: 'Mini tretman između šišanja – glava, šapice, intimna regija.',
    furminatingDesc: 'Uklanjanje poddlake bez oštećenja gornjeg sloja.',
    trimmingDesc: 'Ručna tehnika za oštrodlake rase (šnaucer, foksterijer).',
    
    // Detailed service information
    groomingDetailed: `Profesionalno šišanje prilagođeno tipu dlake, standardu rase ili želji vlasnika uz kompletnu higijenu koja je potrebna Vašem ljubimcu.

Uključeno u tretman: kupanje, pranje zuba, feniranje, sređivanje intimne regije i čišćenje ušiju – jer prava frizura počinje čistim i negovanim psom.`,

    bathingDetailed: `Tretman osvežavanja i dubinskog čišćenja dlake, sa šamponima koji su birani prema tipu kože i potrebama psa. Nakon kupanja, sledi balzam i feniranje kako bi krzno bilo mekano, sjajno i bez ućebaka. Redovna higijena pomaže da dlaka Vašeg psa bude uredna a koža zdrava.

Tretman uključuje: pranje zuba, čišćenje ušiju, sređivanje intimne regije i dodatnu negu, za potpuno čisto i negovano krzno od njuške do repa.`,

    maintenanceDetailed: `Polu tretman kao idealno rešenje između dva šišanja. Sređivanje frizurice na najkritičnijim mestima kao što su predeo glave, šapica i intimne regije bez skraćivanja dlake tela.

Preporučuje se 4 do 6 nedelja nakon kompletnog šišanja.

Pomaže vašem krznenom prijatelju da ostane lep, zdrav i čist do narednog kompletnog tretmana.

Uključeno u svaki tretman: kupanje, pranje zuba, feniranje, sređivanje intimne regije i čišćenje ušiju – kako bi ljubimac uvek bio uredan, svež i spreman za maženje.`,

    furminatingDetailed: `Efikasno uklanjanje poddlake pomoću posebne kozmetike i alata koji ne oštećuju gornji sloj dlake. Savršeno za pse koji se linjaju – smanjuje opadanje dlake i do 90%!

Tretman uključuje: detaljno kupanje, feniranje, pranje zuba, čišćenje ušiju i intimne regije – kompletna nega uz manju količinu dlake po vašem domu!`,

    trimmingDetailed: `Ručna tehnika oblikovanja dlake, pogodna za oštrodlake rase poput šnaucera, foksterijera i džek rasela. Trimovanjem se čuva prirodna tekstura dlake i omogućava zdrav rast.

U okviru tretmana dobijate i: kupanje, feniranje, pranje zuba, sređivanje intimne regije i čišćenje ušiju – jer briga o dlaci počinje od temeljne higijene.`,
    
    // Included services
    included: 'Uključeno',
    groomingIncluded: 'kupanje, pranje zuba, feniranje, intimna regija, uši',
    bathingIncluded: 'zubi, uši, intimna regija, dodatna nega',
    maintenanceIncluded: 'kupanje, feniranje, zubi, uši',
    furminatingIncluded: 'kupanje, zubi, fen, uši, intimna regija',
    trimmingIncluded: 'kupanje, zubi, fen, intimna regija, uši',
    
    // Additional services
    additionalServices: 'Dodatne usluge',
    detangling: 'Rasćebavanje',
    detanglingPrices: '+500 / +1000 / +1500 RSD (zavisno od ućebanosti i veličine psa)',
    parasiteTreatment: 'Tretman protiv parazita',
    parasiteTreatmentPrice: '+500 RSD (uz bilo koji tretman sa kupanjem)',
    
    // Pricing
    pricingTitle: 'Cenovnik',
    pricingSubtitle: 'Transparentne cene za sve naše usluge',
    size: 'Veličina',
    price: 'Cena (RSD)',
    pricingNote: 'Svaki tretman uključuje kupanje, feniranje, sređivanje intimne regije, ušiju i noktiju.',
    
    // About
    aboutTitle: 'O nama',
    aboutText: 'Vaš pas je član vaše porodice – a i naše. Uživamo u svakom tretmanu, pružamo nežnu i profesionalnu negu koristeći prirodnu kozmetiku. Pratimo zdravlje dlake, kože, ušiju i nudimo loyalty programe, popuste na više pasa i poklon kartice.',
    
    // Gallery
    galleryTitle: 'Galerija',
    gallerySubtitle: 'Pogledajte rezultate našeg rada',
    
    // Contact
    contactTitle: 'Kontakt',
    contactSubtitle: 'Imate pitanje? Pišite nam ili nas pozovite',
    name: 'Ime',
    email: 'Email',
    message: 'Poruka',
    sendMessage: 'Pošalji poruku',
    location: 'Lokacija',
    address: 'Adresa',
    workingHours: 'Radno vreme',
    phone: 'Telefon',
    
    // Working hours
    monday: 'Ponedeljak',
    tuesday: 'Utorak',
    wednesday: 'Sreda',
    thursday: 'Četvrtak',
    friday: 'Petak',
    saturday: 'Subota',
    sunday: 'Nedelja',
    closed: 'Zatvoreno',

    // Booking
    bookingBadge: 'Online rezervacija',
    bookingTitle: 'Zakažite termin',
    bookingSubtitle: 'Brza i jednostavna rezervacija — izaberite uslugu, datum i vreme u par koraka.',
    bookAppointment: 'Zakaži termin online',
    bookingStep1: 'Izaberite uslugu i osoblje',
    bookingStep2: 'Izaberite datum',
    bookingStep3: 'Potvrdite vreme termina',
    bookingNote: 'Klikom nastavljate na našu stranicu za online zakazivanje.',
    bookingViaPhone: 'Ili nas pozovite:',
    
    // Footer
    footerText: 'Vaš ljubimac zaslužuje pažnju, negu i osmeh. Hvala vam na poverenju.',
    copyright: '© Hot Dogs – salon za pse',
  },
  
  en: {
    // Navigation
    home: 'Home',
    services: 'Services',
    pricing: 'Pricing',
    about: 'About',
    gallery: 'Gallery',
    contact: 'Contact',
    booking: 'Booking',
    
    // Hero
    heroTitle: 'Your Dog\'s Favorite Place',
    heroSubtitle: 'Enjoying grooming treatment, from snout to tail',
    viewServices: 'View Services',
    contactUs: 'Contact Us',
    
    // Services
    servicesTitle: 'Our Services',
    servicesSubtitle: 'Professional care tailored to your pet\'s needs',
    learnMore: 'Learn More',
    close: 'Close',
    
    // Service names
    grooming: 'Grooming',
    bathing: 'Bathing',
    maintenance: 'Maintenance',
    furminating: 'Furminating',
    trimming: 'Trimming',
    
    // Service descriptions
    groomingDesc: 'Professional grooming tailored to coat type and owner preferences.',
    bathingDesc: 'Refreshing treatment with conditioner, shampoos by skin type.',
    maintenanceDesc: 'Mini treatment between grooming – head, paws, intimate area.',
    furminatingDesc: 'Undercoat removal without damaging the top layer.',
    trimmingDesc: 'Hand technique for wire-haired breeds (schnauzer, fox terrier).',
    
    // Detailed service information
    groomingDetailed: `Professional grooming tailored to coat type, breed standard, or owner preferences with complete hygiene that your pet needs.

Included in treatment: bathing, teeth cleaning, blow-drying, intimate area grooming and ear cleaning – because a proper haircut starts with a clean and well-groomed dog.`,

    bathingDetailed: `Refreshing and deep cleaning treatment for the coat, with shampoos selected according to skin type and dog's needs. After bathing, conditioner and blow-drying follow to make the coat soft, shiny and tangle-free. Regular hygiene helps keep your dog's coat neat and skin healthy.

Treatment includes: teeth cleaning, ear cleaning, intimate area grooming and additional care, for completely clean and well-groomed coat from snout to tail.`,

    maintenanceDetailed: `Half treatment as an ideal solution between two grooming sessions. Tidying up the haircut in the most critical areas such as the head area, paws and intimate area without shortening the body hair.

Recommended 4 to 6 weeks after complete grooming.

Helps your furry friend stay beautiful, healthy and clean until the next complete treatment.

Included in every treatment: bathing, teeth cleaning, blow-drying, intimate area grooming and ear cleaning – so your pet is always neat, fresh and ready for cuddling.`,

    furminatingDetailed: `Effective undercoat removal using special cosmetics and tools that do not damage the top layer of hair. Perfect for dogs that shed – reduces hair loss by up to 90%!

Treatment includes: thorough bathing, blow-drying, teeth cleaning, ear cleaning and intimate area grooming – complete care with less hair around your home!`,

    trimmingDetailed: `Hand technique for shaping hair, suitable for wire-haired breeds like schnauzers, fox terriers and jack russells. Trimming preserves the natural texture of the hair and enables healthy growth.

As part of the treatment you also get: bathing, blow-drying, teeth cleaning, intimate area grooming and ear cleaning – because hair care starts with thorough hygiene.`,
    
    // Included services
    included: 'Included',
    groomingIncluded: 'bathing, teeth cleaning, blow-drying, intimate area, ears',
    bathingIncluded: 'teeth, ears, intimate area, additional care',
    maintenanceIncluded: 'bathing, blow-drying, teeth, ears',
    furminatingIncluded: 'bathing, teeth, blow-dry, ears, intimate area',
    trimmingIncluded: 'bathing, teeth, blow-dry, intimate area, ears',
    
    // Additional services
    additionalServices: 'Additional Services',
    detangling: 'Detangling',
    detanglingPrices: '+500 / +1000 / +1500 RSD (depending on matting and dog size)',
    parasiteTreatment: 'Parasite Treatment',
    parasiteTreatmentPrice: '+500 RSD (with any bathing treatment)',
    
    // Pricing
    pricingTitle: 'Pricing',
    pricingSubtitle: 'Transparent prices for all our services',
    size: 'Size',
    price: 'Price (RSD)',
    pricingNote: 'Every treatment includes bathing, blow-drying, and grooming of the intimate area, ears and nails.',
    
    // About
    aboutTitle: 'About Us',
    aboutText: 'Your dog is a member of your family – and ours too. We enjoy every treatment, providing gentle and professional care using natural cosmetics. We monitor the health of coat, skin, ears and offer loyalty programs, multi-dog discounts and gift cards.',
    
    // Gallery
    galleryTitle: 'Gallery',
    gallerySubtitle: 'See the results of our work',
    
    // Contact
    contactTitle: 'Contact',
    contactSubtitle: 'Have a question? Send us a message or give us a call',
    name: 'Name',
    email: 'Email',
    message: 'Message',
    sendMessage: 'Send Message',
    location: 'Location',
    address: 'Address',
    workingHours: 'Working Hours',
    phone: 'Phone',
    
    // Working hours
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    closed: 'Closed',

    // Booking
    bookingBadge: 'Online booking',
    bookingTitle: 'Book an Appointment',
    bookingSubtitle: 'Quick and easy booking — choose your service, date and time in just a few steps.',
    bookAppointment: 'Book Online',
    bookingStep1: 'Choose service & staff',
    bookingStep2: 'Pick a date',
    bookingStep3: 'Confirm your time slot',
    bookingNote: 'You will be redirected to our secure online booking page.',
    bookingViaPhone: 'Or call us:',
    
    // Footer
    footerText: 'Your pet deserves attention, care and a smile. Thank you for your trust.',
    copyright: '© Hot Dogs – Dog Grooming Salon',
  }
};

export type TranslationKey = keyof typeof translations.sr;